<!--
 * @Author: 曹捷
 * @Date: 2021-03-25 11:16:46
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-03-11 15:55:47
 * @Description: fileContent
-->
<template>
  <a-layout class="full body">
    <a-layout-content class="pd">
      <div class="role-tree" v-if="loading">
        <!-- <a-checkbox v-if="showOpen" v-model:checked="checkedOpen" @change="setCheckedOpen(checkedOpen)">展开/折叠
        </a-checkbox> -->
        <a-checkbox v-if="showAll" v-model:checked="checkedAll" @change="setCheckedAll(checkedAll)">全选/全不选</a-checkbox>
        <!-- <a-checkbox v-if="showPar" v-model:checked="checkedParent" @change="changeParent">父子联动
        </a-checkbox> -->
        <a-tree ref="treeRef" :disabled="disabled" :selectable="selectable" :blockNode="blockNode" :checkStrictly="checkStrictly" :checkable="checkable" :tree-data="treeData"
          v-model:selectedKeys="selectedKeys" v-model:checkedKeys="checkedKeys" :replace-fields="pData" defaultExpandAll style=" border: 1px solid #ccc;border-radius: 3px;">
          <template #title="item">
            <a-button size="small" class="m-r-20 m-l-10" v-if="item.menuType" :type="item.menuType==='F'?'danger':'primary'" ghost>
              {{item.menuType==='F'?'按钮':'菜单'}}</a-button>
            <span class="menuName">{{item.label}}</span>
          </template>
        </a-tree>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import { getCurrentInstance, inject, nextTick, onMounted, reactive, toRefs, watch } from 'vue'
import { util } from 'obit-wui'
export default {
  props: {
    isMenu: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Array,
      default: []
    },
    selectedKeys: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Boolean,
      default: false
    },
    blockNode: {
      type: Boolean,
      default: true
    },
    checkable: {
      type: Boolean,
      default: true
    },
    pData: {
      type: Object
    },
    showOpen: {
      type: Boolean,
      default: true
    },
    showAll: {
      type: Boolean,
      default: true
    },
    showPar: {
      type: Boolean,
      default: true
    },
    //父子联动
    checkedParent: {
      type: Boolean,
      default: false
    },
    //展开、折叠
    checkedOpen: {
      type: Boolean,
      default: false
    },
    //全选、全不选
    checkedAll: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    let { proxy } = getCurrentInstance()
    let http = inject('http')
    let _data = reactive({
      checkedKeys: {
        checked: []
      },
      loading: false,
      selectedKeys: [],
      treeAllKeys: [],
      treeRef: null,
      checkStrictly: true
    })
    let _methods = {
      getSelectKey () {
        let _halfCheckedKeys = _data.treeRef.tree._halfCheckedKeys
        return [..._halfCheckedKeys, ..._data.checkedKeys.checked]
      },
      setCheckedAll (item) {
        _data.checkedKeys = item === true ? _data.treeAllKeys : []
      },
    }
    onMounted(() => {
      http.getTreeAllKeys(props.treeData, props.selectedKeys).then(res => {
        _data.treeAllKeys = util.util.cloneObj(res.arrKey)
        _data.checkedKeys = props.isMenu ? props.selectedKeys.concat(res.appKey) : props.selectedKeys
        _data.checkedKeys.checked = props.isMenu ? props.selectedKeys.concat(res.appKey) : props.selectedKeys
        _data.selectedKeys = props.isMenu ? props.selectedKeys.concat(res.appKey) : props.selectedKeys
        _data.loading = true
      })

    })
    return {
      ...toRefs(_data),
      ..._methods
    }
  }
}
</script>

<style lang="less">
.bindrole {
  .ant-layout-footer {
    text-align: right;
    padding: 10px 20px;
    background: #fff;
    box-shadow: 0 2px 22px 0 rgba(0, 0, 0, 0.12), 0 0 7px 0 rgba(0, 0, 0, 0.04);
  }
  .role-tree {
    margin-top: 20px;
    .ant-tree {
      border: 1px solid #ccc;
      border-radius: 3px;
    }
    .ant-tree-node-content-wrapper {
      height: auto;
      .ant-tree-title {
        display: inline-block;
      }
    }
    .menuType {
      height: 35px;
      line-height: 35px;
    }
  }
}
</style>